import React, { useState,useEffect } from "react";
import { IconButton, Paper, TextField } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { Email, Padding, Visibility, VisibilityOff } from "@mui/icons-material";

import swal from "sweetalert";


function ChoosePlan() {

  
  
  return (
    <div className="container">
        <div className="bg-white">
     <div className="row ">

     </div>
     <div className="row mt-4 p-4">
<div className="col-md-4">
    <div>
<p className="color-gray">Starter</p>
</div>
<div className="d-flex">
    <span><h4>₹149.00</h4></span><span className="color-gray">/ &nbsp;&nbsp;Month</span>
</div>
<p className="color-gray">get our starter plan for getting email level of verifications</p>
<div>
<span style={{color:"lightpink",borderRadius:"10px"}}>
    <input type="checkbox" checked={true} className="" />
  </span>
</div>
</div>
<div className="col-md-4">

</div>
<div className="col-md-4">

</div>
<div className="col-md-4">

</div>
     </div>
     </div>
    </div>
  );
}

export default ChoosePlan;
